<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-21"></a><span href="#/toc#toc-chapter003" title="Link target outside of Sample">3</span></h1>
<p class="noindent"><span class="dropcap"><em>M</em></span>ore frightening than the gun she was holding was her attitude of utter invulnerability. She stood like a soldier, right arm
         braced around the wrist by the left hand, sighting with her dominant eye, stance open and finger tickling the trigger.
      </p>
<p>She knew with absolute certainty they would never dare shoot a nun.</p>
<p>“Turn around, walk away,” she said. “You’ve lost this time.”</p>
<p>Of course, she could only aim at one of them at a time, and she did so without mercy. The target of her intentions started
         to crumble.
      </p>
<p>“We just want the girl,” said the man. “Just the girl.”</p>
<p>“No,” said the nun. The girl in question took a step back behind the nun’s skirts and played with her necklace.</p>
<p>“She can’t get both of us,” said the other man, and took an exploratory step forward.</p>
<p>“I wouldn’t bet my life on it,” said the nun. “More to the point, you shouldn’t bet your life on it. I don’t carry this cannon
         around for show.”
      </p>
<p><a id="page-22"></a>“If I can interrupt,” said Petrovitch from the floor. He swallowed around the knot of acid pain in his throat. “You don’t
         have time for this. You see that pendant in your target’s hand? It’s a panic button. I’m guessing she’s had her thumb jammed
         on it for the last few minutes, and the signal it’s giving off is stationary. Which means the cavalry are going to be no more
         than, what, thirty seconds away?”
      </p>
<p>He would have said more, but his vision flashed white again, and he momentarily lost muscle control. The back of his head
         banged against the floorboards.
      </p>
<p>He heard, “What the hell’s the matter with him?” and “What are we going to do?”</p>
<p>They weren’t smart. They weren’t even up to the standards of Petrovitch’s old boss. He struggled to his elbows again, blinking
         at their stupidity. “Really. You’d better go now. Go.”
      </p>
<p>The surge of electricity through his heart took him down again. For the fourth time. It had never done that before. The sparks
         in his sight looked like angels against the vaulted roof space.
      </p>
<p>“<em>Chyort,</em>” he whispered, then he noticed that no one had moved. He gathered what was left of his strength and hissed “Run!”
      </p>
<p>They started to edge away, and their first tentative movements rapidly translated into full flight. They burst out into the
         daylight, and it was there, framed against the shadow, that they were scythed down.
      </p>
<p>At the first shot, the nun flattened the girl with a sweep of her legs and threw herself on top of Petrovitch. Her veil covered
         his face, forming a seal over his mouth. He couldn’t breathe, but as she lay across his ribs with her <a id="page-23"></a>full weight, there wasn’t much point in trying. She had even managed to pin his arms; he couldn’t so much as bat his hands
         against her. He struggled weakly and uselessly. He was powerless to save himself; of all the stupid ways to go, crushed by
         a nun.
      </p>
<p>The roar of gunfire went on for longer than was ever necessary. Someone determinedly made a point while Petrovitch meekly
         suffocated.
      </p>
<p>It became abruptly silent, and after a pause that was almost his undoing, the nun looked up. Her veil swung to one side, and
         he managed to drag in a wheezing gasp of air.
      </p>
<p>He coughed, and filled his lungs again. The air tasted of dust, cordite and blood.</p>
<p>“Stay down,” she said, not realizing that Petrovitch had no option but to obey. Figures made their way through the haze and
         picked their way over the ruined bodies of the two dead men.
      </p>
<p>These men also had guns; long-barrelled assault rifles with smoke still curling from their muzzles. They carried them easily,
         like workmen who knew they’d completed the day’s task.
      </p>
<p>“Miss Sonja?” said one, a pocket-sized man with a shaved head. He stepped out of the clearing air and looked sadly around
         him.
      </p>
<p>“I’m here,” said the woman. She picked herself off the floor and shook out the hem of her skirt.</p>
<p>“We should go,” said the man, “Your father is worried about you.” He brushed a chip of plaster off his suited shoulder while
         he too waited. The rest of his team materialized behind him. To a man—and they were all men—they were Japanese.
      </p>
<p><a id="page-24"></a>“I’m ready.” She walked toward the doors, the security men surrounding her. She stopped at the entrance to the porch, and
         looked round at the only other people who had helped her that morning. She screwed up her face, and came back. She leaned
         over them, and Petrovitch thought it an extraordinary thing that her hair had managed to fall into place with no effort at
         all.
      </p>
<p>“Miss Sonja? The police will be here soon. It would be best to avoid them at the moment.”</p>
<p>She held up her hand in a way that indicated that she was in charge now.</p>
<p>“Is he going to be Okay?” she asked the nun.</p>
<p>“I think,” she said, with a surprising amount of viciousness for someone in holy orders, “he needs an ambulance.”</p>
<p>“I’ll have one called. Hijo?”</p>
<p>“Yes, Miss Sonja. At once.”</p>
<p>“I do have to go.” But then she knelt next to Petrovitch, her presence forcing the nun back on her haunches. “Who are you?”</p>
<p>Petrovitch panted to give himself a voice. “If you’re <em>yakuza,</em> I don’t want you to know.”
      </p>
<p>“<em>Yakuza?</em> What a ridiculous idea.”
      </p>
<p>His gaze moved from her outrage to the nun’s skepticism, to the gun-toting suits glancing out of the door and eager to be
         away.
      </p>
<p>“I’m not getting involved with you,” he said.</p>
<p>“Involved? You saved my life.”</p>
<p>“Stupid me. Now do me a favor and save mine: go.”</p>
<p>She looked hurt; more upset at his slight than at nearly getting kidnapped. Sirens penetrated the thick stone walls, and she
         picked herself up from the floor. The man she <a id="page-25"></a>called Hijo was trying to bury his agitation beneath the sheen of civility; he even had the temerity to take her gently at
         one elbow and guide her outside.
      </p>
<p>The last rifle-toting gunman left the church, leaving Petrovitch, the nun, and two ruined corpses.</p>
<p>“Do I get to find out who you are?” she asked. She released the slide on her automatic, discharging the shiny unspent bullet
         into her palm.
      </p>
<p>“Petrovitch,” said Petrovitch.</p>
<p>“Just Petrovitch?” She clicked on the safety and slid out the magazine to click the bullet back into the clip.</p>
<p>“It’ll do.”</p>
<p>“Sister Madeleine,” she said. “I’m a Joan.”</p>
<p>“Yeah. Figured. What with the Papal seal on your <em>pushka</em> and your complete lack of fear.” He gave up trying to sit, and attempted to roll over instead. The effort was too much for
         him, and he concluded that he might actually be dying.
      </p>
<p>“Is there anything I can do?”</p>
<p>He looked up into her big brown eyes properly, now that no one was trying to kill him. His heart stopped again, only for a
         moment, but he put it down to his arrhythmia. “If you haven’t got a scalpel, some bolt cutters and a set of rib spreaders,
         no. The defibrillator that’s part of my pacemaker seems to have crashed.”
      </p>
<p>“Crashed?”</p>
<p>“Normally I go to a hospital and they reprogram it. Five-minute job. Only I need it to work right now and I don’t think I
         have five minutes.
      </p>
<p>She slung her automatic into her holster and scooped him up in her arms. It was only then that he realized that she was huge.
         Tall, proportionately built; a giantess. She <a id="page-26"></a>carried him out to the streetside and stood on the last wide step of a series that led up to the main doors.
      </p>
<p>The traffic had flooded back onto the road, as had the pedestrians to the pavement. Sister Madeleine spotted over everyone’s
         heads that, miracle of miracles, an ambulance was fighting its way through to the curb in a blizzard of red and blue.
      </p>
<p>“At least your little friend did that right.” She adjusted the weight in her arms, aimed his feet toward the mass of people
         that stood in her way, and barged through. From the way he kept feeling impacts on the soles of his boots, he realized that
         the sight of a two-meter-tall fully-robed novice nun cradling a semi-conscious man wasn’t strange enough for hardened Metrozone
         residents to take much notice. The sister was determined, however, and they met the ambulance as it shuddered to a halt.
      </p>
<p>The paramedics took him from her, and laid him efficiently on a stretcher inside the van. He watched as they attacked his
         shirt with scissors and pasted cold electrodes to his skinny chest. It was only when they tried to put a mask over his face
         that he rebelled and turned his face away.
      </p>
<p>“The nun. Where is she?”</p>
<p>She climbed up and crouched down. “What is it?”</p>
<p>If she’d been expecting a message for someone or a death-bed confession, she was going to be disappointed. “My bag.”</p>
<p>“Your what?”</p>
<p>“My bag. Courier bag.”</p>
<p>“It’s back in the church.” She pulled back the side of her veil so she could press her ear close to his mouth. “Is there something
         important in it?”
      </p>
<p><a id="page-27"></a>“Hardware. Cost me a small fortune and I’ve not even turned it on yet.”
      </p>
<p>She sat back. “A computer? Your heart’s about to fail and you’re worried about a shiny new computer?”</p>
<p>“Look after it for me.”</p>
<p>“Petrovitch,” she said, “you, you geek.”</p>
<p>“Sister,” said the paramedic who was wincing at the vital signs on his handheld screen. “In or out, but we’re moving.”</p>
<p>She made to leave, but ended up reaching out of the cabin and pulling the doors shut, trapping herself inside. “Just drive,”
         she muttered, and sat awkwardly in a fold-down seat that wasn’t anywhere near her size. She pulled her veil straight and reached
         for her rosary to compose herself.
      </p>
<p>Sister Madeleine watched Petrovitch flat-line three times in the ten minutes it took to get him to the hospital, and each
         time he came back to life again he searched the interior of the ambulance for her.
      </p>
<p>Some of the time, he was thinking about his beautiful piece of bespoke kit, lying untended on a pew in a city-center church
         where anyone could just walk in and take it.
      </p>
<p>But part of him wondered what she was thinking, and he couldn’t work that out at all.</p>
<p class="space-break">It involved less surgery and more coding. No one cut him wide open, which he was grateful for. The chip that was supposed
         to control his errant heart was pulled bloodily out through a hole, and a new one slotted into place. He was kept conscious
         throughout.
      </p>
<p>The morphine and exhaustion made him drowsy though, <a id="page-28"></a>and at some point when they were sewing up the access wound with short, blunt tugs of black thread, he allowed himself the
         luxury of falling asleep.
      </p>
<p>He dreamed: cold snow, cold wind, crystal-black nights and needle-bright stars. He dreamed of ribbons of auroral color above
         the blank skyline, of the Soviet murals that decorated the foyers of the underground. He dreamed of good vodka and good friends.
      </p>
<p>When he woke up, he found that he’d left all that behind and exchanged it for a pale cream room with hospital bed, polarizing
         filters on the window and an amazonian nun in the corner. Perhaps the nun was optional; then again, for one to come as standard
         made as much sense as anything in his life ever did.
      </p>
<p>“How long?” he asked.</p>
<p>“Hour, maybe,” she said. She stood by his bed and looked around. “This must cost a fortune.”</p>
<p>“More than my modest insurance could afford.” Petrovitch pushed himself up with his hands and accepted the automatic movement
         of his pillows. Sister Madeleine looked down to see what her hands were doing—shaping and plumping—and she consciously stopped
         herself.
      </p>
<p>“So?”</p>
<p>Petrovitch leaned back. He could feel the tightness in his chest, but no pain. That was good. “Miss Sonja wanted to know who
         I was. The only way she could do that was to pick up the tab on my hospital bill. It’ll be no more than small change for someone
         like her, and she’ll consider herself clever because she’s found out who I am.”
      </p>
<p>Sister Madeleine shrugged. “You got something out of it too.”</p>
<p>“Yeah. Why do you think I didn’t tell her my name?”</p>
<p><a id="page-29"></a>She saw his sly smile. “You were dying, and you saw the opportunity to get a room upgrade?”
      </p>
<p>“And a private ambulance. I didn’t need her gratitude, I needed her influence. And look: I’m still alive.”</p>
<p>Her eyes grew large. “That’s, that’s…”</p>
<p>“What?” Petrovitch was nonplussed by her reaction. “Just because you didn’t work it out.”</p>
<p>“Why? Why would someone like you want to help someone like her?” She put her hands on her hips and waited for Petrovitch to
         answer. When he didn’t, she said: “You know what? I don’t care. I haven’t got the energy to waste on it. You know where to
         find me if you want your little box of tricks back.”
      </p>
<p>She strode to the door, the second time that day a pretty woman had turned her back on him and walked away.</p>
<p>“I don’t,” he said. “I don’t know where to find you. I wasn’t aware of where I was for the last five minutes or so of the
         chase.”
      </p>
<p>She faced the closed door. “So you want me to tell you? What if I don’t? What then?”</p>
<p>“I’ll work it out. It can’t be that difficult. Five minutes, maybe. Ten, then—tops. All I want is my bag back. Really.” He
         had no idea why he was having this conversation. “Sister?”
      </p>
<p>“Saint Joseph of Arimathea, Edgware Road.” She twisted the doorknob, and the door swung aside.</p>
<p>“Sister?”</p>
<p>“What?”</p>
<p>He thought about mentioning that she had nearly suffocated him with that stupid head-dress of hers, and for once found that
         sarcasm died on his tongue. “Thank you. I’m grateful.”
      </p>
<p><a id="page-30"></a>She shrugged again. “Doing good things is in the job description, Petrovitch.” She looked down at the patient, crumpled man
         sitting across the corridor from her. “Police are here.”
      </p>
<p>She left, robes billowing out behind her. Neither man, the one in the bed, the one in the chair, had the authority to stop
         her.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?ea194d00